export default __webpack_public_path__ + "static/media/hht1_ep19_timeline_q02_a.b55da552.png";